import React from 'react';

const ItemComment = (props) => {
    return (
        <div className="item-comment">
            <div className="style-cmnt">
                <div className="pic">
                    <img
                        src={props.data.user_photo}
                        onError={(e) => {
                            console.log(e.target.src = "/img/default-user-image.png")
                        }} />
                </div>
                <div className="cntnt">
                    <div className='cm'>
                        <h4>{props.data.user_name}</h4>
                        <div className='rate'>
                            <span>{props.data.rate}</span>
                            <i className='icon-black-star-silhouette'></i>
                        </div>
                    </div>
                    <p>{props.data.comment}</p>
                    <span>{props.data.date}</span>
                </div>
            </div>
            {props.data.has_reply ?
                <div className="style-cmnt admin-cmnt">
                    <div className="pic">
                        <img src={props.data.reply.user_photo} />
                    </div>
                    <div className="cntnt">
                        <h4>{props.data.reply.user_name}</h4>
                        <p>{props.data.reply.comment}</p>
                        <span>{props.data.reply.date}</span>
                    </div>
                </div>
                :
                null
            }
        </div>
    );
}

export default ItemComment;